import { useEffect } from "react";
import Lenis from "lenis";
import { setLenis } from "./lib/scroll";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Problem from "./components/Problem";
import Intro from "./components/Intro";
import Platform from "./components/Platform";
import Journey from "./components/Journey";
import Outcomes from "./components/Outcomes";
import Institutions from "./components/Institutions";
import Framework from "./components/Framework";
import FinalCTA from "./components/FinalCTA";

const GRAIN =
    "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        setLenis(lenis);
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            setLenis(null);
        };
    }, []);

    return (
        <div className="min-h-screen bg-paper font-sans text-ink antialiased">
            <div
                aria-hidden
                className="pointer-events-none fixed inset-0 z-[90] opacity-[0.035] mix-blend-multiply"
                style={{ backgroundImage: GRAIN }}
            />
            <Nav />
            <main>
                <Hero />
                <Problem />
                <Marquee />
                <Intro />
                <Platform />
                <Journey />
                <Outcomes />
                <Institutions />
                <Framework />
                <Marquee dark />
                <FinalCTA />
            </main>
        </div>
    );
}

export default App;
